import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Member } from '../../../../models/member.model';
import { UserModel } from '../../../../models/user.model';
import {
  MemberType,
  MembershipStatus,
} from '../../../../models/membership.status';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import * as memberActions from '../../../../state/actions/member.actions';
import { AppState } from '../../../../state/appstate';
import * as memberSelector from '../../../../state/selectors/member.selector';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';
import { BtnMemberStatusComponent } from '../../../components/buttons/btn-member-status/btn-member-status.component';
import { DlgSelectOptionComponent } from '../../../components/dialogs/dlg-select-option/dlg-select-option.component';
import { ViewLocationComponent } from '../../../components/maps/view-location/view-location.component';

@Component({
  selector: 'app-detail-member',
  standalone: true,
  templateUrl: './detail-member.component.html',
  imports: [
    CommonModule,
    RouterModule,
    ViewLocationComponent,
    MatDialogModule,
    BtnMemberStatusComponent,
    BtnBackComponent,
    InitialsPipe,
    MomentPipe,
  ],
  styleUrls: ['./detail-member.component.css'],
})
export class DetailMemberComponent implements OnInit, OnDestroy {
  route: ActivatedRoute = inject(ActivatedRoute);
  private dialog: MatDialog = inject(MatDialog);

  groupId: string | null = null;
  memberId: string | null = null;

  member: Member | null | undefined;
  memberSub: Subscription | undefined;

  user: UserModel | null = null;
  userSub: Subscription | undefined;

  membershipStatus = MembershipStatus;
  memberType = MemberType;

  constructor(private store: Store<AppState>) {
    this.route.paramMap.subscribe((params) => {
      this.groupId = params.get('id');
      this.memberId = params.get('memberId');
    });
  }
  ngOnDestroy(): void {
    this.memberSub?.unsubscribe();
    this.userSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.memberSub = this.store
      .pipe(select(memberSelector.getMemberById(this.memberId!)))
      .subscribe((member) => {
        this.member = member;
      });

    this.userSub = this.store
      .select((state) => state.user.user)
      .subscribe((user) => {
        this.user = user;
      });
  }

  get firstName(): string {
    if (!this.member?.name) return '';
    const parts = this.member.name.trim().split(/\s+/);
    return parts[0] || '';
  }

  get lastName(): string {
    if (!this.member?.name) return '';
    const parts = this.member.name.trim().split(/\s+/);
    return parts.slice(1).join(' ') || '';
  }

  changeStatusDialog(currentStatus: MembershipStatus | undefined) {
    let data: any = [];
    switch (currentStatus) {
      case MembershipStatus.active:
        data = [
          MembershipStatus.active,
          MembershipStatus.rejected,
          MembershipStatus.removed,
        ];
        break;
      case MembershipStatus.invited:
        data = [MembershipStatus.invited, MembershipStatus.removed];
        break;
      case MembershipStatus.rejected:
        data = [
          MembershipStatus.rejected,
          MembershipStatus.active,
          MembershipStatus.removed,
        ];
        break;
      case MembershipStatus.requested:
        data = [
          MembershipStatus.requested,
          MembershipStatus.active,
          MembershipStatus.rejected,
        ];
        break;
      default:
        data = [];
        break;
    }
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      title: 'Update Member Status',
      description: 'Select the new member status and proceed',
      options: data,
      action: 'Update',
      selectedOption: currentStatus,
    };
    const dialogRef = this.dialog.open(DlgSelectOptionComponent, dialogConfig);

    return dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && this.member) {
        return this.store.dispatch(
          memberActions.updateStatus({
            id: this.member?.id!,
            member: { status: result } as Member,
          }),
        );
      }
      return;
    });
  }
}
